import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import get from 'lodash/get';
import set from 'lodash/set';
var techSpecKeys = ['Model', 'Usage', 'Configuration', 'Connectivity', 'Frequency', 'TX Power', 'TX Distance', 'Power Supply', 'Operating Temperature', 'Security', 'Mounting', 'Dimensions', 'Weight', 'Standard', 'Battery', 'Battery Life', 'Firmware', 'Precision', 'Installation Height', 'Other'];
export default {
  name: 'NiotaClassicDevicetypesCreateEditDialog',
  mixins: [formMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isEditForm: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      techSpecKeys: techSpecKeys,
      accounts: [],
      deviceTypes: [],
      niotaImportClipboard: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isSuperSystemAdmin: function isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    showImportClipboard: function showImportClipboard() {
      return !this.isEditForm && this.isSuperSystemAdmin;
    },
    visibilityItems: function visibilityItems() {
      return [{
        text: this.$i18n_t('NiotaClassic.DeviceTypes.visibility.account'),
        value: 'account'
      }, {
        text: this.$i18n_t('NiotaClassic.DeviceTypes.visibility.everyone'),
        value: 'everyone'
      }];
    },
    cardButtons: function cardButtons() {
      return [{
        icon: 'fas fa-save',
        title: this.formItem.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.saveAndCreate'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    formValue: function formValue() {
      return this.$refs.form ? this.$refs.form.value : false;
    }
  }),
  watch: {
    isOpen: function isOpen(state) {
      if (state) {
        this.initializeForm();
      }
    }
  },
  created: function created() {
    this.initializeForm();
  },
  methods: {
    get: get,
    initializeForm: function initializeForm() {
      var _this = this;

      this.formItem = cloneDeep(this.editedItem || {});
      this.prepareFormItem();
      NiotaClassicApiService.accountsFetchPlain().then(function (res) {
        _this.accounts = res.data.accounts;
      }).catch(function () {
        _this.$snack(_this.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchAccountFailed'), 'error');
      });
      NiotaClassicApiService.deviceTypesGetPlain().then(function (res) {
        _this.deviceTypes = res.data.devicetypes;
      }).catch(function () {
        _this.$snack(_this.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchFailed'), 'error');
      });
    },
    attachmentsUpdated: function attachmentsUpdated(data) {
      this.formItem.properties.manufacturer.device_manual_file = data;
    },
    // FIXME: get deviceTypeVariables, parserVariables, variableTypeFinder methods from niota-classic/devices/detailsMixin.js
    deviceTypeVariables: function deviceTypeVariables(deviceType) {
      var _this2 = this;

      var variableKeys = [];
      var type = deviceType.parser.type; //parser type single

      if (type === 'single' || type === 'function') {
        variableKeys = this.parserVariables(deviceType.parser.config.variables || {});
      } //parser type multi


      if (type === 'multi') {
        var parsers = Object.keys(deviceType.parser.config || {});
        parsers.forEach(function (parser_n) {
          var indivParserVariables = parser_n !== '__switch' ? deviceType.parser.config[parser_n].variables || [] : [];
          Object.keys(indivParserVariables).forEach(function (variable) {
            variableKeys.push({
              variable: indivParserVariables[variable]['name'] ? indivParserVariables[variable]['name'] : '',
              parser: parser_n,
              value_type_name: _this2.variableTypeFinder(indivParserVariables[variable])
            });
          });
        });
      }

      return variableKeys;
    },
    parserVariables: function parserVariables(deviceTypeVariables) {
      var _this3 = this;

      var variables = [];
      Object.keys(deviceTypeVariables).forEach(function (key) {
        variables.push({
          variable: deviceTypeVariables[key]['name'] ? deviceTypeVariables[key]['name'] : '',
          value_type_name: _this3.variableTypeFinder(deviceTypeVariables[key])
        });
      });
      return variables;
    },
    variableTypeFinder: function variableTypeFinder(variable) {
      var variableType = '';

      if (variable) {
        if (variable['suffix']) {
          variableType = variable['suffix'];

          if (variable['value_type'] && variable['value_type'].name) {
            variableType = variable['value_type'].name;
          }
        } // for boolean case


        if (variable['value_type']) {
          if (variable['value_type'] && variable['value_type'].name) {
            variableType = variable['value_type'].name;
          }
        }
      }

      return variableType;
    },
    prepareFormItem: function prepareFormItem() {
      if (!this.formItem.properties) {
        this.formItem.properties = {};
        this.formItem.properties.certified = false;
        this.formItem.properties.certifiedBy = this.isSuperSystemAdmin ? 'DIGIMONDO' : null;
      }

      if (!this.formItem.properties.manufacturer) {
        this.formItem.properties.manufacturer = {};
      }

      if (!isArray(this.formItem.properties.manufacturer.device_manual_file)) {
        if (this.formItem.properties.manufacturer.device_manual_file && this.formItem.properties.manufacturer.device_manual_file.constructor === Object) {
          this.formItem.properties.manufacturer.device_manual_file = [this.formItem.properties.manufacturer.device_manual_file];
        }
      }

      if (!this.formItem.properties.technical_specs) {
        this.formItem.properties.technical_specs = {};
      }
    },
    handleImport: function handleImport(deviceTypeObject) {
      if (isObject(deviceTypeObject)) {
        delete deviceTypeObject.id;
        delete deviceTypeObject.accountId;
        delete deviceTypeObject.account;
        deviceTypeObject.properties.certified = false;
        this.formItem = cloneDeep(deviceTypeObject);
        this.prepareFormItem();
      }
    },
    handleImportClipboard: function handleImportClipboard() {
      var _this4 = this;

      NiotaClassicApiService.deviceTypesValidateCopy(this.niotaImportClipboard).then(function (res) {
        _this4.formItem = res.data.devicetype;

        if (!_this4.isSuperSystemAdmin) {
          _this4.formItem.certified = false;
          _this4.formItem.properties.certifiedBy = null;
        }

        _this4.copySourceInfo = res.data.devicetype.properties.sourceInfo;
        _this4.formItem.copy = res.data.devicetype.title;

        _this4.$refs.form.validate();
      }).catch(function () {
        _this4.$snack(_this4.$i18n_t('NiotaClassic.DeviceTypes.snacks.validateClipboardFailed'), 'error');
      });
    },
    createOrUpdateDeviceType: function createOrUpdateDeviceType() {
      if (this.formItem.id) {
        this.updateRequest();
      } else {
        this.createRequest();
      }
    },
    updateRequest: function updateRequest() {
      var _this5 = this;

      NiotaClassicApiService.deviceTypesUpdate(this.formItem.id, this.formItem).then(function () {
        _this5.$emit('update', _this5.formItem);

        _this5.$emit('close');

        _this5.$snack(_this5.$i18n_t('NiotaClassic.DeviceTypes.snacks.updateSuccess'), 'success');
      }).catch(function () {
        _this5.$snack(_this5.$i18n_t('NiotaClassic.DeviceTypes.snacks.updateFailed'), 'error');
      });
    },
    createRequest: function createRequest() {
      var _this6 = this;

      NiotaClassicApiService.deviceTypesCreate(this.formItem).then(function () {
        _this6.$emit('created');

        _this6.$emit('close');

        _this6.$snack(_this6.$i18n_t('NiotaClassic.DeviceTypes.snacks.createSuccess'), 'success');
      }).catch(function () {
        _this6.$snack(_this6.$i18n_t('NiotaClassic.DeviceTypes.snacks.createFailed'), 'error');
      });
    },
    accountUpdated: function accountUpdated() {
      if (this.formItem.account) {
        this.formItem.accountId = this.formItem.account.id;
      }
    },
    uploadImage: function uploadImage(image) {
      var _this7 = this;

      NiotaClassicApiService.uploadImage(image, 'devicetype').then(function (data) {
        _this7.formItem.image = data.files[0];
        _this7.formItem = cloneDeep(_this7.formItem);
      }).catch(function () {
        _this7.$snack(_this7.$i18n_t('NiotaClassic.DeviceTypes.snacks.imageUploadFailed'), 'error');
      });
    },
    updateModel: function updateModel() {
      this.formItem = cloneDeep(this.formItem);
    },
    selectedBattery: function selectedBattery(item) {
      if (!item) {
        return;
      }

      if (item.value_type_name === 'Boolean' || get(this.formItem, 'properties.battery_type') === 'Boolean') {
        set(this.formItem, 'properties.battery_warning_level', '');
        set(this.formItem, 'properties.battery_alert_level', '');
      }

      set(this.formItem, 'properties.battery_level', item.variable);
      set(this.formItem, 'properties.battery_type', item.value_type_name);
    }
  }
};